import headerTemplate from './header-templates';
import { emptyElement } from '../../utils/utils';
import styles from './header.css';
import Icon from '../icon/icon.js';
import getConfig from '../../env.js';
import { doLogout, isDisplayHeader } from '../../../src/api/api.js';

const arrElements = [];

function onDocClick(containerId, itemId) {
  const val = `${containerId},${itemId}`;
  if (arrElements.indexOf(val) === -1) {
    arrElements.push(val);
  }
}

document.onclick = function docClick() {
  arrElements.forEach((val) => {
    const splitItem = val.split(',');
    const containerId = splitItem[0];
    const itemId = splitItem[1];
    const item = document.getElementById(containerId);
    const activeId = document.activeElement.id;
    if (containerId !== 'userProfileImage') {
      if (item && activeId !== itemId) {
        const specific = document.getElementById(itemId);
        specific.setAttribute('aria-expanded', 'false');
        item.parentNode.removeChild(item);
      }
    } else if (item && activeId !== itemId && activeId !== 'userProfileImage') {
      const specific = document.getElementById(itemId);
      item.setAttribute('aria-expanded', 'false');
      specific.style.setProperty('display', 'none');
    }
  });
};

function getActivitySubMenuHideHTML(submenu) {
  let valList = `<ul tabindex="-1" class="${styles.dropdownMenu__menu} ${styles.hide}" id='subMenuList'>`;
  // eslint-disable-next-line array-callback-return
  submenu.map((item) => {
    if (item.submenu === undefined) {
      valList += `<li class=${styles.dropdownMenu__menu__item}>
        <a href=${item.link} role='menuitem'>${item.title}</a>
        </li>`;
    }
  });
  valList += '</ul>';
  return valList;
}

function getActivitySubMenuHTML(submenu, currentTarget, node, idVal) {
  const controlledElementIds = currentTarget.getAttribute('id');
  const foo = node.querySelector(`#${controlledElementIds}`);
  const ariaExpanded = foo.getAttribute('aria-expanded');
  const parent = foo.parentNode;
  const helper = document.createElement('div');
  if (ariaExpanded === 'false') {
    foo.setAttribute('aria-expanded', 'true');
    let valList = `<ul tabindex="-1" role="menu" id="ul${idVal}" aria-labelledby="${idVal}" class="${styles.dropdownMenu__menu} ${styles.show}">`;
    // eslint-disable-next-line array-callback-return
    submenu.map((item) => {
      if (item.submenu === undefined) {
        valList += `<li class="${styles.dropdownMenu__menu__item}">
        <a href=${item.link} role='menuitem'>${item.title}</a>
        </li>`;
      } else {
        valList += `<li class="${styles.dropdownMenu__menu__item}" id='submenuDropDown' tabIndex="0">
        <a href=${item.link} role='menuitem'>${item.title}
          <i class="${styles.spanIcon} ${styles.iconSvgSize} ${styles.dropdownMenu__menu__item__icon}">${Icon('arrowSmallRight')}</i>
        </a>`;
        valList += getActivitySubMenuHideHTML(item.submenu);
        valList += '</li>';
      }
    });
    valList += '</ul>';
    helper.innerHTML = valList;
    while (helper.firstChild) {
      parent.insertBefore(helper.firstChild, foo.nextSibling);
    }
    const subMenuButton = document.querySelector('#submenuDropDown');
    if (subMenuButton) {
      subMenuButton.addEventListener('mouseover', () => {
        requestAnimationFrame(() => {
          document.querySelector('#subMenuList').setAttribute('class', `${styles.dropdownMenu__menu} ${styles.show}`);
        });
      });

      subMenuButton.addEventListener('mouseout', () => {
        requestAnimationFrame(() => {
          document.querySelector('#subMenuList').setAttribute('class', `${styles.dropdownMenu__menu} ${styles.hide}`);
        });
      });
    }
  } else {
    parent.removeChild(parent.lastElementChild);
    foo.setAttribute('aria-expanded', 'false');
  }
}

function getAlertMenuContentHTML(genericAlerts, receiveAlerts, currentTarget, node, trans) {
  const controlledElementIds = currentTarget.getAttribute('id');
  const foo = node.querySelector(`#${controlledElementIds}`);
  const ariaExpanded = foo.getAttribute('aria-expanded');
  const parent = foo.parentNode;
  const helper = document.createElement('div');
  if (ariaExpanded === 'false') {
    foo.setAttribute('aria-expanded', 'true');
    let valList = `<section id="alertsMenu" class="${styles.alertsDropdown__menu} ${styles.show}">
    <h1 class=${styles.alertsDropdown__menu__header}>${trans.notifications}</h1>`;
    valList += `<ul class=${styles['list-unslyted']} role="menu" tabIndex="-1">`;
    if (genericAlerts) {
      // eslint-disable-next-line array-callback-return
      genericAlerts.map((alert) => {
        valList += `<li
              tabIndex="0"
              role="menuitem"
              class=${styles.alertsDropdown__menu__item}>
              <a href=${alert.href} target="_blank" rel="noopener noreferrer">
                ${alert.title}
              </a>
            </li>`;
      });
    }
    if (receiveAlerts) {
      // eslint-disable-next-line array-callback-return
      receiveAlerts.map((alert) => {
        valList += `<li
              tabIndex="0"
              role="menuitem"
              class=${styles.alertsDropdown__menu__item}>
              <a href=${alert.href} target="_blank" rel="noopener noreferrer">
                ${alert.title}
              </a>`;
        if (alert.redeem && alert.redeem.href) {
          valList += `<a class='oct-common-header-primary-background-color' href=${alert.redeem.href}>${alert.redeem.title}</a>`;
        }
        valList += '</li>';
      });
    }
    valList += '</ul></section>';
    helper.innerHTML = valList;
    while (helper.firstChild) {
      parent.insertBefore(helper.firstChild, foo.nextSibling);
    }
  } else {
    parent.removeChild(parent.lastElementChild);
    foo.setAttribute('aria-expanded', 'false');
  }
}

function getCatalogButtonHTML(catalogLink, banks, trans, hasGivenWidgetEnabled) {
  let valList = '';
  if (banks && banks.length > 0) {
    valList = `<div 
    class="${styles.catalogButtonContainer} ${hasGivenWidgetEnabled ? '' : `${styles.withOutWidget}`}" role="presentation">`;
    valList += `<a href="${catalogLink}" 
    class="${styles.catalogButton} ${hasGivenWidgetEnabled ? '' : `${styles.catalogButtonStyle} oct-common-header-primary-background-color`}">`;
    if (banks.length > 0 && hasGivenWidgetEnabled) {
      valList += `<span>${banks[0].points} </span><span id="points">${banks[0].name}</span>`;
    } else if (!hasGivenWidgetEnabled) {
      valList += `<span>${trans.catalog}</span><span> • </span><span> ${banks[0].points ? banks[0].points : 0}</span>`;
    } else {
      valList += '<span>0</span>';
    }
    valList += `</a><button 
    class="${styles.catalogButtonTrigger} 
    ${hasGivenWidgetEnabled ? '' : `${styles.catalogButtonArrowStyle} oct-common-header-primary-background-color`}" 
    data-toggle="dropdown" id="catalogButtonTrigger" 
      aria-expanded="false" aria-haspopup="true">`;
    valList += `<i class="${styles.spanIcon} ${styles.iconSvgSize}">${Icon('arrowSmallDown')}</i></button></div>`;
  }
  return valList;
}

function getCatalogMenuContentHTML(banks, awards, catalogs, currentTarget, node, trans) {
  const controlledElementIds = currentTarget.getAttribute('id');
  const foo = node.querySelector(`#${controlledElementIds}`);
  const ariaExpanded = foo.getAttribute('aria-expanded');
  const parent = foo.parentNode;
  const helper = document.createElement('div');
  if (ariaExpanded === 'false') {
    foo.setAttribute('aria-expanded', 'true');
    let valList = `<div role="menu" id="catalogMenuDiv" tabindex="-1" class=${styles.catalogMenu}>`;
    if (banks.length > 0) {
      valList += `<section id="catalogMenu">
      <div role="menuitem" tabindex="0">
        <h1 class=${styles.catalogMenu__header}>${banks[0].isPointsBank ? trans['bank-accounts'] : trans['access-codes']}</h1>
      </div>
      <ul class=${styles['list-unslyted']}>`;
      // eslint-disable-next-line array-callback-return
      banks.map((bank) => {
        valList += `<li><a href=${bank.link}
        title='${bank.name} ${bank.points}'
        class=${styles.catalogMenu__item}
        role="menuitem">
        <span className=${styles['pull-left']}>
          ${bank.name}`;
        if (bank.isCurrentBank) {
          valList += `<i class=${styles.spanIcon}>${Icon('check')}</i></span>`;
        } else {
          valList += '</span>';
        }
        valList += `<span class=${styles['pull-right']}>
          ${bank.points}
        </span>
        </a>
        </li>`;
      });
      valList += '</ul></section>';
    }
    if (awards.length > 0) {
      valList += `<section><div role="menuitem" tabindex="0"><h1 class=${styles.catalogMenu__header}>${trans['unredeemed-awards']}</h1></div>
      <ul class=${styles['list-unslyted']}>`;
      // eslint-disable-next-line array-callback-return
      awards.slice(0, 4).map((award) => {
        valList += `<li><a href=${award.link}
        class=${styles.catalogMenu__item}
        role="menuitem">
        <span className=${styles['pull-left']}>
          ${award.name}</span>`;
        valList += `<span class=${styles['pull-right']}>
          ${award.expires}
        </span>
        </a>
        </li>`;
      });
      if (awards.length > 5) {
        valList += `<li>
        <a
          href="/myaccount/history.seam"
          title="${trans['view-more']}"
        >
        ${trans['view-more']}
        </a>
      </li>`;
      }
      valList += '</ul></section>';
    }
    if (catalogs.length > 0) {
      valList += `<section><div role="menuitem" tabindex="0"><h1 class=${styles.catalogMenu__header}>View Awards</h1></div>
      <ul class=${styles['list-unslyted']}>`;
      // eslint-disable-next-line array-callback-return
      catalogs.map((catalog) => {
        valList += `<li><a href=${catalog.link}
        title=${catalog.title}
        class=${styles.catalogMenu__item}
        role="menuitem">
        ${catalog.title}
        </a>
        </li>`;
      });
      valList += '</ul></section>';
    }
    valList += '</div>';
    helper.innerHTML = valList;
    while (helper.firstChild) {
      parent.insertBefore(helper.firstChild, foo.nextSibling);
    }
  } else {
    parent.removeChild(parent.lastElementChild);
    foo.setAttribute('aria-expanded', 'false');
  }
}


function getAlertButtonHTML(alertsCount) {
  let valList = `<div class="${styles.alertsDropdown}" id="alertsButtonContainer" role="presentation">`;
  valList += `<button class="${styles.alertsDropdown__button}" data-toggle="dropdown" id="alertsButton" 
    aria-expanded="false" aria-haspopup="true" ${alertsCount > 0 ? '' : 'disabled'}>
    <i class="${styles.alertsDropdown__button__icon}">
      ${Icon('notification')}
    </i>`;

  if (alertsCount > 0) {
    valList += `<span class=${styles.alertsDropdown__button__count}>${alertsCount}</span>`;
  }
  valList += '</button></div>';
  return valList;
}

function addGiveWidget(lang) {
  // eslint-disable-next-line no-undef
  if (GiveWidget) {
    // eslint-disable-next-line no-new, no-undef
    new GiveWidget.Create('#giveWidget', { language: lang });
    const eleGiveWidget = document.getElementById('giveWidget');
    if (eleGiveWidget) {
      eleGiveWidget.tabIndex = -1;
    }
  }
}

function replaceString(str) {
  const val = str.toLowerCase();
  return val.replace(/ /g, '').replace(/'/g, '');
}

class Header {
  defaultProps = {
    catalogLink: '',
    banks: [],
    awards: [],
    catalogs: [],
    genericAlerts: [],
    receiveAlerts: [],
    alertsCount: -1,
    hasGivenWidgetEnabled: false,
    isEclientLink: false,
    customerName: ''
  };

  set isEclientLink(x) {
    if (isDisplayHeader()) {
      this.props.isEclientLink = x;
    }
  }

  set catalogLink(catalogLink) {
    if (isDisplayHeader()) {
      this.props.catalogLink = catalogLink;
    }
  }

  get catalogLink() {
    return this.props.catalogLink;
  }

  set customerName(customerName) {
    this.props.customerName = customerName;
  }

  get customerName() {
    return this.props.customerName;
  }

  set tasksCount(count) {
    if (this.node && isDisplayHeader()) {
      const foo = this.node.querySelector('.tasks-link');
      foo.insertAdjacentHTML('beforeend', `<span class="${styles.notif_tasks_count}">${count}</span>`);
    }
  }

  set banks(bankData) {
    this.props.banks = bankData;
    if (this.node && isDisplayHeader()) {
      const foo = this.node.querySelector('#giveWidget');
      if (foo) {
        const parent = foo.parentNode;
        const helper = document.createElement('div');
        helper.innerHTML = getCatalogButtonHTML(this.catalogLink, this.banks, this.translations, this.hasGivenWidgetEnabled);
        while (helper.firstChild) {
          parent.insertBefore(helper.firstChild, foo);
        }
        const catalogButton = document.querySelector('#catalogButtonTrigger');
        if (catalogButton) {
          catalogButton.addEventListener('click', (evt) => {
            const { currentTarget } = evt;
            requestAnimationFrame(() => {
              onDocClick('catalogMenuDiv', 'catalogButtonTrigger');
              getCatalogMenuContentHTML(this.banks, this.awards, this.catalogs, currentTarget, this.node, this.translations);
            });
          });
        }
      }
    }
  }

  get banks() {
    return this.props.banks;
  }

  set alertsCount(alertsCount) {
    if (isDisplayHeader()) {
      this.props.alertsCount = alertsCount;
    }
  }

  get alertsCount() {
    return this.props.alertsCount;
  }

  set genericAlerts(genericAlerts) {
    if (isDisplayHeader()) {
      this.props.genericAlerts = genericAlerts;
    }
  }

  get genericAlerts() {
    return this.props.genericAlerts;
  }

  set awards(awardsData) {
    if (isDisplayHeader()) {
      this.props.awards = awardsData;
    }
  }

  get awards() {
    return this.props.awards;
  }

  set catalogs(catalogsData) {
    if (isDisplayHeader()) {
      this.props.catalogs = catalogsData;
    }
  }

  get catalogs() {
    return this.props.catalogs;
  }

  constructor(selector, { desktopSidebarIsToggleable = false } = {}) {
    this.props = { ...this.defaultProps };
    this.catalogLink = this.props.catalogLink;
    this.banks = this.props.banks;
    this.awards = this.props.awards;
    this.catalogs = this.props.catalogs;
    this.genericAlerts = this.props.genericAlerts;
    this.receiveAlerts = this.props.receiveAlerts;
    this.alertsCount = this.props.alertsCount;
    this.hasGivenWidgetEnabled = this.props.hasGivenWidgetEnabled;
    this.currentSelectedLanguage = this.props.currentSelectedLanguage;
    this.translations = this.props.translations;
    this.customerName = this.props.customerName;
    const node = document.querySelector(selector);
    this.desktopSidebarIsToggleable = desktopSidebarIsToggleable;
    if (node) {
      this.node = node;
    } else {
      console.error(`element, ${selector}, should exist for Common Header to work properly`);
    }
    this.toggleSidebar = () => {};
  }


  set logo(url) {
    if (this.node) {
      this.node.querySelector(`#${styles.logo}`).setAttribute('src', url);
    }
  }

  set logolink(link) {
    if (this.node) {
      this.node.querySelector('#logolink').setAttribute('href', link);
    }
  }

  set activity(activity) {
    if (activity.length > 0 && isDisplayHeader()) {
      // eslint-disable-next-line array-callback-return
      activity.map((item) => {
        const foo = this.node.querySelector('#page-links');
        // const parent = foo.parentNode;
        const helper = document.createElement('div');
        if (item.submenu === undefined) {
          // eslint-disable-next-line no-template-curly-in-string
          helper.innerHTML = `
            <a href=${item.link} tabIndex="0" class="${styles.activityMenuLink} ${item.specialClass ? item.specialClass : ''}">${item.title}</a>
          `;
          while (helper.firstChild) {
            // foo.insertBefore(helper.firstChild, foo.nextSibling);
            foo.appendChild(helper.firstChild);
          }
        } else {
          let idModified = '';
          if (idModified !== undefined && idModified.length === 0) {
            const arr = item.link.split('/');
            idModified = arr.pop();
            idModified = idModified.replace(/\./g, '_');
          }
          if (idModified !== undefined && idModified.length === 0) {
            idModified = replaceString(item.title);
          }
          const val = `<div class="${styles.dropdownMenuWrapper} ${styles.inline}" role="presentation">
          <button type='button' 
            data-toggle="dropdown" id="${idModified}" class=${styles.dropdownMenu__button} aria-expanded="false" aria-haspopup="true">
            <span class=${styles.myaccountAlign}>${item.title}</span>
            <i class="${styles.spanIcon} ${styles.iconSvgSize}">${Icon('arrowSmallDown')}</i>
          </button>
          </div>`;
          helper.innerHTML = val;
          while (helper.firstChild) {
            // helper.onclick = subMenuNode(item.submenu);
            // foo.insertBefore(helper.firstChild, foo.nextSibling);
            foo.appendChild(helper.firstChild);
          }
          if (idModified && idModified.length > 0) {
            const myAccountButton = document.querySelector(`#${idModified}`);
            if (myAccountButton) {
              myAccountButton.addEventListener('click', (evt) => {
                const { currentTarget } = evt;
                requestAnimationFrame(() => {
                  onDocClick(`ul${idModified}`, idModified);
                  getActivitySubMenuHTML(item.submenu, currentTarget, this.node, idModified);
                });
              });
            }
          }
        }
      });
    }
  }

  get hasGivenWidgetEnabled() {
    return this.props.hasGivenWidgetEnabled;
  }

  set hasGivenWidgetEnabled(enabled) {
    if (isDisplayHeader()) {
      this.props.hasGivenWidgetEnabled = enabled;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  set widget(widget) {
    if (widget && isDisplayHeader()) {
      if (typeof GiveWidget === 'undefined') {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = getConfig('GIVE_WIDGET_CSS');
        document.head.appendChild(link);
        const script = document.createElement('script');
        script.src = getConfig('GIVE_WIDGET_JS');
        document.head.appendChild(script);
        script.onload = () => {
          addGiveWidget(this.currentSelectedLanguage);
        };
      } else {
        addGiveWidget(this.currentSelectedLanguage);
      }
    }
  }

  set cartLink(url) {
    if (url && url.length > 0 && isDisplayHeader()) {
      const foo = this.node.querySelector('#giveWidget');
      const parent = foo.parentNode;
      const helper = document.createElement('div');
      // eslint-disable-next-line no-template-curly-in-string
      helper.innerHTML = `<a href=${url} tabIndex="0" class=${styles.cartButton} id='cartbutton'>
        <i class="${styles.cartButton__icon} ${styles.spanIcon} ${styles.iconSvgSize}">${Icon('shoppingCart')}</i>
      </a>`;
      while (helper.firstChild) {
        parent.insertBefore(helper.firstChild, foo);
      }
    }
  }

  set receiveAlerts(receiveAlerts) {
    this.props.receiveAlerts = receiveAlerts;
    if (this.node && !this.props.isEclientLink && isDisplayHeader()) {
      const foo = this.node.querySelector('#giveWidget');
      const parent = foo.parentNode;
      const alertsButtonEle = document.querySelector('#alertsButtonContainer');
      if (alertsButtonEle) {
        alertsButtonEle.parentNode.removeChild(alertsButtonEle);
      }
      if (parent) {
        // const parent = foo.parentNode;
        const helper = document.createElement('div');
        helper.innerHTML = getAlertButtonHTML(this.alertsCount);
        const { firstChild } = parent;
        while (helper.firstChild) {
          parent.insertBefore(helper.firstChild, firstChild);
        }
        if (this.genericAlerts.length > 0 || this.receiveAlerts.length > 0) {
          const alertButton = document.querySelector('#alertsButton');
          if (alertButton) {
            alertButton.addEventListener('click', (evt) => {
              const { currentTarget } = evt;
              requestAnimationFrame(() => {
                onDocClick('alertsMenu', 'alertsButton');
                getAlertMenuContentHTML(this.genericAlerts, this.receiveAlerts, currentTarget, this.node, this.translations);
              });
            });
          }
        }
      }
    }
  }

  set greeting(obj) {
    if (obj && obj.name && isDisplayHeader()) {
      const foo = this.node.querySelector('#giveWidget');
      const parent = foo.parentNode;
      const helper = document.createElement('div');
      // eslint-disable-next-line no-template-curly-in-string
      helper.innerHTML = `<div class="${styles.userProfile}">
        <button id="userProfileImage" class="${styles.userProfileBtn}" aria-expanded="false">
          <img id="userAvatar" src="${obj.image}" alt="User Profile image" />
        </button>
        <div id="logoutSpace" class="${styles.loginContainer}">
          <div class="${styles.triangle}">
            <div class="${styles.userName}">
              ${obj.name}
            </div>
            <div class="${styles.logout}">
              <a target="_self" href="#" id='logoutUserLink'>
                <i class="">
                  ${Icon('lock')}
                </i>
                <span>
                  ${obj.logoutTitle}
                </span>
              </a>
            </div>
          </div>
          </div>
        </div>
      </div>`;
      while (helper.firstChild) {
        parent.appendChild(helper.firstChild, foo);
      }

      const userProfile = document.getElementById('userProfileImage');
      const logoutUser = document.getElementById('logoutUserLink');
      if (userProfile) {
        onDocClick('userProfileImage', 'logoutSpace');
        userProfile.addEventListener('click', () => {
          setTimeout(() => {
            const ariaExpanded = userProfile.getAttribute('aria-expanded');
            const logoutSpace = document.getElementById('logoutSpace');
            if (ariaExpanded === 'true') {
              logoutSpace.style.setProperty('display', 'none');
              userProfile.setAttribute('aria-expanded', 'false');
            } else {
              logoutSpace.style.setProperty('display', 'inline');
              userProfile.setAttribute('aria-expanded', 'true');
            }
          }, 0);
        });
      }
      if (logoutUser) {
        logoutUser.addEventListener('click', () => {
          doLogout(obj.logoutLink);
        });
      }
    }
  }

  get receiveAlerts() {
    return this.props.receiveAlerts;
  }

  set translations(trans) {
    this.props.translations = trans;
  }

  get translations() {
    return this.props.translations;
  }

  setToggleSidebar(fn) {
    const ele = document.querySelector(`.${styles.hamburger}`);
    if (ele) {
      ele.removeEventListener('click', this.toggleSidebar);
      this.toggleSidebar = fn;
      ele.addEventListener(
        'click',
        this.toggleSidebar
      );
    }
  }

  render = () => {
    emptyElement(this.node);
    const frag = document.createRange().createContextualFragment(headerTemplate({
      desktopSidebarIsToggleable: this.desktopSidebarIsToggleable, customerName: this.customerName
    }));
    this.node.appendChild(frag);
    document.querySelector(`.${styles.hamburger}`).addEventListener(
      'click',
      this.toggleSidebar
    );
  }
}

export default Header;
